import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Card } from '../card.model';
import { State } from '../state/state';
import * as fromCard from '../state/selectors';

@Injectable()
export class CardQuery {

  constructor(private store: Store<State>) { }

  get values(): Observable<Card[]> {
    return this.store.pipe(
      select(fromCard.getCards)
    );
  }

}
